export default __webpack_public_path__ + "static/media/collapse-side-bar.bd8c050d.svg";